import Tippy from '@tippyjs/react';
import bem from '../../../utils/bem';
import Icon from '../Icon/Icon';

const Tip = ({
  maxWidth = 200,
  content,
  iconWidth = 16,
  iconHeight = 16,
  allowHTML,
  interactive,
  mods,
  extra,
}) => {
  const componentClassName = 'a-tip';
  return (
    <Tippy
      content={<div dangerouslySetInnerHTML={{ __html: content }}></div>}
      maxWidth={maxWidth}
      zIndex={10100}
      allowHTML={allowHTML}
      interactive={interactive}
    >
      <button
        className={bem(componentClassName, mods, '', extra)}
        aria-label={Drupal.t('Tooltip')}
      >
        <Icon iconName="question-mark" width={iconWidth} height={iconHeight} />
      </button>
    </Tippy>
  );
};

export default Tip;
